export const FETCH_CORRESPONSALES_SUCCESS = 'FETCH_CORRESPONSALES_SUCCESS';
export const FETCH_CORRESPONSALES_FAILURE = 'FETCH_CORRESPONSALES_FAILURE';
